import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useContext } from 'react';
import { Spring } from 'react-spring';
import { OrderDetailsContext } from '../../context/OrderDetailsContext';
import './_verticalProgress.scss';

const VerticalProgress = ({ orderIsCancelled, orderDispatched, progress }) => {
  const [orderCompleted, setOrderCompleted] = useState('false');
  const [statusTimeStamp, setStatusTimeStamp] = useState();
  const { orderDetail } = useContext(OrderDetailsContext);
  const [orderStatusHistories, setOrderStatusHistories] = useState([]);
  const [progressHeight, setProgressHeight] = useState('0');

  const [acknowledgedStatusTime, setAcknowledgedStatusTime] = useState(0);

  // get all the available order status histories
  useEffect(() => {
    setOrderStatusHistories(orderDetail?.response?.orderStatusHistories);
  }, [orderDetail]);

  // sort the order histories with timestamp
  const sortedOrderStatusHistories = orderStatusHistories?.sort(function (
    a,
    b
  ) {
    var c = a.syncedOn;
    var d = b.syncedOn;
    return c - d;
  });

  useEffect(() => {
    //* new way
    if (orderDetail?.response?.orderState === 'Completed') {
      setOrderCompleted('true');
      setStatusTimeStamp(
        moment(orderDetail?.response?.lastUpdatedStatusOn).format()
      );
    }

    sortedOrderStatusHistories
      ?.filter((orderStatuses) => orderStatuses.status === 'Acknowledged')
      ?.map((order) => {
        setAcknowledgedStatusTime(moment(order?.syncedOn).format());
      });
  }, [sortedOrderStatusHistories, orderDetail]);

  useEffect(() => {
    if (acknowledgedStatusTime != 0) {
      setProgressHeight('37');
    }

    if (orderDispatched == true) {
      setProgressHeight('67');
    }

    if (orderCompleted == 'true') {
      setProgressHeight('100');
    }

    if (orderIsCancelled == 'true') {
      setProgressHeight('0');
    }
  }, [
    orderCompleted,
    orderDetail,
    orderIsCancelled,
    orderDispatched,
    acknowledgedStatusTime,
  ]);

  return (
    <Spring
      from={{ percent: 0 }}
      to={{
        percent: progress,
      }}
    >
      {({ percent }) => (
        <div
          className="progress vertical"
          style={{
            height: `${progressHeight == '100' ? '94%' : '93%'}`,
          }}
        >
          <div
            style={{
              // height: `${orderCompleted === 'true' ? 100 : progress}%`,
              height: `${progressHeight}%`,
              maxHeight: '100%',
            }}
            className={`progress-bar ${
              orderIsCancelled === 'true'
                ? 'emptyBar'
                : `${progress >= 101 ? 'amber' : 'green'}`
            }`}
          >
            <div
              className={`${
                progressHeight < 14 ||
                progressHeight >= 100 ||
                progressHeight === 0 ||
                orderCompleted === 'true'
                  ? 'hide'
                  : 'currentTime'
              }`}
            >
              <div className="r-tooltip"></div>
            </div>
            <div
              className={
                orderCompleted === 'true'
                  ? 'star'
                  : `${
                      progress < 14 ||
                      progress > 100 ||
                      progress === 0 ||
                      orderCompleted !== 'true'
                        ? 'hide'
                        : 'currentTime'
                    }`
              }
            >
              {/* {progress > 13 && progress <= 100 && ( */}
              {progress > 0 && (
                <div className="r-tooltip">
                  {statusTimeStamp && (
                    <>
                      {moment(statusTimeStamp).format('LT')}
                      {/* <span style={{ fontStyle: 'italic' }}>Delivered At</span> */}
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </Spring>
  );
};

export default VerticalProgress;
